import axios from "axios";
import { handleReturnedError } from "../utils/handleReturnedError";
import { UrlConstants } from "../utils/ApiConstants";
import { replaceWithCurrentApiVersion } from "../utils/api";


function apiSendData(url:string,controller:any, method:string, headers:any, data:any, resolve:any, reject:any) {
  axios({
    method: method,
    url: `${UrlConstants.BASE_URL}` + replaceWithCurrentApiVersion(url),
    data: JSON.stringify(data),
    headers: headers,
  })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      handleReturnedError(err, reject);
    });
}


export { apiSendData };
